/*
 * Modals using fancy box.
 */
var ModalController = (function($) {

	var win, doc, dump,
		modalParam = /(?:\?|&)modal=([^&]+)(?:$|&)/gi,
		modalSelector = ".modal-content",
		videoSelector = ".video-container",
		focusableElements = ["a","button","input","link","select","textarea","iframe"],
		focusableSelector = focusableElements.join(","),
		lastFocus = null;

	function ready() {
		win = $(window);
		doc = $(document.body);
		dump = $("<div />");

		doc.on("click", ".modal-trigger", onModalOpenClick);
		doc.on("click", ".modal-close", onModalCloseClick);
		doc.on("change", "select.modal-trigger", onModalSelectChange);
		doc.on("focus", focusableSelector, onElementFocus);
		doc.on("keyup", onKeyUp);

        doc.on("keydown", "a.fancybox-close", preventModalTabOut);

        function preventModalTabOut(e) {
            var key = e.which || e.keyCode;
            if (key != 9) { // Tab.
                return;
            }
            $(modalSelector)
                .find(focusableSelector)[0]
                .focus();
            return false;
        };

		var qs = document.location.search;
		var m = modalParam.exec(qs);

		if (m && m.length > 1) {
			var val = decodeURIComponent(m[1]);
			// If this starts with a slash, then it's supposed to be a path to a video so treat it as such and use the path to load the given video even though it might not be on the same page.
			if (/^\//gi.test(val)) {
				var a = $("<a />");
				a.attr("href", val);
				pullFromHref.call(a);
			} else if (/open/i.test(val)) {
				// Open the first modal that can be found on the screen.
				onModalOpenClick.call($(".modal-trigger.video")[0]);
			} else {
				// Default case will treat the value as a jQuery selector and open that as a modal.
				var modalTrigger = $(val);
				if (modalTrigger.length > 0) {
					onModalOpenClick.call(modalTrigger[0]);
				}
			}
		}
	}

	function onElementFocus(e) {
		var me = $(e.target);
		var inFancybox = me.closest(".fancybox-wrap").length > 0;
		if (!inFancybox) {
			e.stopPropagation();
			closeAllModals();
		}
	}

	function onKeyUp(e) {
		// Let TAB through because we want the user to be able to navigate.
		if (e.keyCode === 9) { // TAB
			return;
		}
		switch (e.keyCode) {
			case 27: // ESC
				closeAllModals();
				break;
		}
	}

	// Move the fancybox from it's default location outside of the <form> tag to
	// the end of the #root element so the styles cascade correctly.
	function fixFancyboxPosition() {
		var fbox = $(".fancybox-overlay, .fancybox-mobile");
		var root = $("#root");
		if (root.length > 0 && !fbox.parent().is("#root")) {
			fbox.detach();
			$("#root").append(fbox);
		}
	}



	function afterFancyboxLoad(current, previous) {
		fixFancyboxPosition();
	}

	function afterFancyboxShow() {
		setFocusToModal.apply(this, arguments);
		
		// Re-equalize any grids that might have ended up in the modal.
		if (typeof(GridController) !== "undefined") {
			GridController.equalizeGrids();
		}
	}

	function setFocusToModal(current, previous) {
	    var inner = $(this.inner),
	        focusableElements = inner.find(focusableSelector);

        // Set tab order so that when tabbing out of the modal the user should proceed back to the element that opened the modal and not the end of the document.
	    focusableElements.add("a.fancybox-close").each(function (i) {
	        $(this).attr("tabindex", i + 1);
	    });
	    var content = focusableElements.first();
		content.focus();
	}

  function afterClose() {
    if (lastFocus) {
      lastFocus.focus();
    }
	}

	function onModalOpenClick(e) {
	  var clicked = $(this),
	    isMobile = BreakpointController.isMobile(),
	    forceOnMobile = clicked.attr("data-modal-mobile") === "true";
	  lastFocus = clicked;

		if (clicked.is("select") || (isMobile && !forceOnMobile)) {
			return true;
		}
		if (e) {
			e.preventDefault();
			e.stopPropagation();
		}
		closeAllModals();
		if (clicked.attr("data-modal-target")) {
			pullFromElement.apply(this, arguments);
		} else {
			pullFromHref.apply(this, arguments);
		}
		return false;
	}

	/*
	 * On modal close click, close the fancybox modals.
	 */
	function onModalCloseClick(e) {
		e.preventDefault();
		closeAllModals();
	}

	function closeAllModals() {
        if ($.fancybox) {
            $.fancybox.close(true);
        }
	}

	// For a dropdown, if a given value is supposed to trigger the modal,
	// mark those values in an attribute.
	function onModalSelectChange(e) {
		var clicked = $(e.currentTarget);
		// Get selected options
		var option = clicked.children("option:selected");
		var modalSelector = option.attr("data-modal-target");
		if (modalSelector) {
			var contentTarget = $(modalSelector);
			if (contentTarget.length > 0) {
				$.fancybox({
					content: contentTarget.html(),
					afterLoad: afterFancyboxLoad,
					afterShow: afterFancyboxShow,
					afterClose: afterClose
				});
			}
		}
	}

	/*
	 * Pull the data for the modal from the URL provided in the href attribute.
	 */
	function pullFromHref(e) {
		var clicked = $((e) ? e.currentTarget : this);
		var url = clicked.attr("href");
        if (!url) {
            return;
        }
		var operator = (url.indexOf("?") < 0) ? "?" : "&";
		dump.load(url + operator + "modaltrigger=true", function() {
			var modalContent = dump.find(videoSelector);
			if (modalContent.length === 0) {
				modalContent = dump.find(modalSelector);
			}
			if (modalContent.length > 0) {
				modalContent.addClass("modal-content-active");
				var html = "";
				modalContent.each(function() {
					html += $("<div />").append($(this).clone()).html();
				});
				$.fancybox({
					content: html,
					afterLoad: afterFancyboxLoad,
					afterShow: afterFancyboxShow,
					afterClose: afterClose
				});
			}
		});
	}

	/*
	 * Pull HTML content into the modal from a target element.
	 */
	function pullFromElement(e) {
		var clicked = $((e) ? e.currentTarget : this),
			targetSelector = "" + clicked.attr("data-modal-target");

		try {
			var contentTarget = $(targetSelector);
			if (contentTarget.length > 0) {
				$.fancybox({
					content: contentTarget.html(),
					afterLoad: afterFancyboxLoad,
					afterShow: afterFancyboxShow,
					afterClose: afterClose
				});
			}
		} catch (err) {
		}
	}

	/*
	* Open up a fancybox modal
	*/
	function openContentModal(opts) {
		opts = opts || {};
		opts.content = opts.content || "";
		opts.afterLoad = opts.afterLoad || afterFancyboxLoad;
		opts.afterShow = opts.afterShow || afterFancyboxShow;
		opts.afterClose = opts.afterClose || afterClose;
		return $.fancybox(opts);
	}

	$(ready);

	return {
		ready: ready,
		fixFancyboxPosition: fixFancyboxPosition,
		openContentModal: openContentModal
	};

})(jQuery);

if (typeof Sys !== "undefined") {
	var prm = Sys.WebForms.PageRequestManager.getInstance();

	prm.add_endRequest(function() {
		ModalController.ready();
	});
}
